@use "../../../../styles/text";

hp6-inline-validator {
  .validation-message {
    @include text.text-body-xs;
    margin-top: var(--spacing-xxs);
    color: var(--color-text-base);
    line-height: var(--text-body-line-height-xxs);

    .valid {
      color: var(--color-success-base);
    }

    .invalid {
      color: var(--color-error-base);
    }
  }

  &[alignment-selection="center"] {
    text-align: center;
  }
}
